import _ from "lodash";
import UserService from '@/services/UserService';

const defaultState = () => ({
  showcase: null,
  showcasePublic: null,
});

const state = defaultState();

const mutations = {
  GET_SHOWCASE(state, showcase) {
    state.showcase = showcase
  },
  GET_PUBLIC_SHOWCASE(state, showcase) {
    state.showcasePublic = showcase
  },
  ADD_STREAM(state, stream) {
    if (stream.type === 'live') {
      state.showcase.streams.push(stream)
      state.showcase.streamOrder.push(stream._id)
    } else {
      state.showcase.vods.push(stream)
      state.showcase.streamOrder.push(stream.refId ? stream.refId : stream.id)
    }
  },
  DELETE_STREAM(state, stream) {
    const newStreams = state.showcase.streams.filter(streamElement => streamElement._id !== stream._id)
    state.showcase.streams = newStreams
    const newStreamOrder = state.showcase.streamOrder.filter(id => id !== stream._id)
    state.showcase.streamOrder = newStreamOrder
  },
  
};

const actions = {
  async getShowcase({ commit }, id) {
    const showcase = await UserService.getShowcase();
    commit("GET_SHOWCASE", showcase);
  },
  async getPublicShowcase({ commit }, id) {
    const showcase = await UserService.getShowcasePublic(id);
    commit("GET_PUBLIC_SHOWCASE", showcase);
  },
  addStream({ commit }, stream) {
    commit("ADD_STREAM", stream);
  },
  deleteStream({ commit }, stream) {
    commit("DELETE_STREAM", stream);
  },
  
};

const getters = {
  showcase: (state) => state.showcase,
  showcasePublic: (state) => state.showcasePublic,
  shouldPublish: (state) => {
    // If either showcase is null, consider them different
    if (!state.showcase || !state.showcasePublic) {
      return true
    }
    // Compare settings
    if (!_.isEqual(state.showcase.settings, state.showcasePublic.settings)) {
      return true
    }
    // Compare stream IDs and their order
    const showcaseStreamIds = state.showcase.streams.map(s => s._id)
    const publicStreamIds = state.showcasePublic.streams.map(s => s._id)
    if (!_.isEqual(showcaseStreamIds, publicStreamIds)) {
      return true
    }
    // Compare VOD IDs
    const showcaseVodIds = state.showcase.vods.map(v => v.id)
    const publicVodIds = state.showcasePublic.vods.map(v => v.id)
    if (!_.isEqual(showcaseVodIds, publicVodIds)) {
      return true
    }
    // Compare streamOrder
    if (!_.isEqual(state.showcase.streamOrder, state.showcasePublic.streamOrder)) {
      return true
    }
    return false
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
